import { IntegrationAppProvider } from "@membranehq/react";
import { useCurrentUser } from "../../hooks/QueryHooks";
import { generateIntegrationAppToken } from "../../services/integrationAppEndpoint";
import useWorkspaceStore from "../../store/workspace/workspaceStore";

interface MemberLevelIntegrationProviderProps {
  children: React.ReactNode;
}

const MemberLevelIntegrationProvider = ({ children }: MemberLevelIntegrationProviderProps) => {
  const workspace = useWorkspaceStore((state) => state.workspace);
  const { data: user }: any = useCurrentUser({});

  const fetchMemberLevelToken = async () => {
    if (workspace?.id && user?.user_id) {
      try {
        const response = await generateIntegrationAppToken({
          workspace_id: workspace.id,
          isMemberLevel: true
        });
        return response?.data?.token;
      } catch (error) {
        console.error('Failed to fetch member-level integration token:', error);
        return null;
      }
    }
    return null;
  };

  return (
    <IntegrationAppProvider fetchToken={fetchMemberLevelToken}>
      {children}
    </IntegrationAppProvider>
  );
};

export default MemberLevelIntegrationProvider;
